import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { desktop, mobile } from "../../theme";

import { Picture, TwoOne } from "../Layout/Layout";

import { Quotes } from "../guide/Stream/3/WhatsWatch/Quote";

const ChannelStyled = styled("div")({
  display: "flex",
  flexDirection: "column",
  counterIncrement: "game",
});

const Title = styled("div")(
  css({
    fontSize: [3, 5],
    fontWeight: "bold",
    marginBottom: [20, 34],
    "::before": {
      content: "counter(game) '. '",
    },
  })
);

const Description = styled("div")(
  css({
    p: {
      m: 0,
      ":not(:last-child)": {
        mb: "1.2em",
      },
    },
    [mobile]: {
      fontSize: 1,
    },
    [desktop]: {
      fontSize: 3,
      "& > *": {
        width: "90%",
      },
    },
  })
);

const PictureStyled = styled(Picture)({
  position: "relative",
  "img:not([class])": {
    width: "100%",
    [desktop]: {
      position: "absolute",
    },
  },
});

const QuotesStyled = styled(Quotes)({
  [mobile]: {
    order: 2,
  },
  [desktop]: {
    marginRight: 400,
  },
});
const Reqs = styled("div")(
  css({
    fontSize: 1,
    marginBottom: ["10px", "35px"],
  })
);
const Genre = styled("div")(
  css({
    fontSize: [1, 3],
  })
);
const Content = styled("div")({});

export const Game = ({
  name,
  reqs,
  genre,
  age,
  imgSrc,
  beforeQuotes,
  quotes,
  children,
}) => (
  <ChannelStyled>
    <TwoOne>
      <Content>
        <Title>{name}</Title>
        <Reqs>({reqs})</Reqs>
        <Genre>
          <strong>Жанр:</strong> {genre}
          <br />
          <strong>Возраст:</strong> {age}
        </Genre>
      </Content>
      {imgSrc && (
        <PictureStyled>
          <img alt="" src={imgSrc} />
        </PictureStyled>
      )}
    </TwoOne>
    <TwoOne>
      <Content>
        <Description>{children}</Description>
      </Content>
    </TwoOne>
    {beforeQuotes}
    {quotes && <QuotesStyled>{quotes}</QuotesStyled>}
  </ChannelStyled>
);

export const Games = styled("div")(
  css({
    [ChannelStyled]: {
      ":not(:first-child)": {
        marginTop: [60, 200],
      },
    },
  })
);
